import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function getIFProfile() {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .get(`${url}/report/sample/if_profile`, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/report/sample/if_profile <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getIMRProfile() {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .get(`${url}/report/sample/imr_profile`, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/report/sample/imr_profile <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getCompanyProfile() {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .get(`${url}/report/sample/company_profile`, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/report/sample/company_profile <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getIFReport() {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .get(`${url}/report/sample/if_report`, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/report/sample/if_report <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getIMRReport() {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .get(`${url}/report/sample/imr_report`, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/report/sample/imr_report <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getCompanyReport() {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .get(`${url}/report/sample/company_report`, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/report/sample/company_report <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getValuationReport() {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .get(`${url}/report/sample/valuation_report`, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/report/sample/valuation_report <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}


export default {
  getIFProfile,
  getIMRProfile,
  getCompanyProfile,
  getIFReport,
  getIMRReport,
  getCompanyReport,
  getValuationReport
};
